import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { AlertTriangle } from "lucide-react";

import { Button } from "@/shared/components/ui/button";

export function RouteErrorBoundary() {
  const error = useRouteError();

  const title = isRouteErrorResponse(error)
    ? `${error.status} — ${error.statusText}`
    : "Algo salió mal";
  const message = isRouteErrorResponse(error)
    ? ((error.data as string | undefined) ?? "Error del router")
    : error instanceof Error
      ? error.message
      : "Error desconocido";

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-4 bg-arya-bg px-4 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-destructive/10 text-destructive">
        <AlertTriangle className="h-7 w-7" />
      </div>
      <div>
        <h1 className="text-2xl font-semibold">{title}</h1>
        <p className="mt-1 max-w-md text-sm text-muted-foreground">{message}</p>
      </div>
      <Button onClick={() => window.location.reload()}>Recargar</Button>
    </div>
  );
}
